import { FC } from 'react';
import { Name, RecipeImage } from './RecipeThumb.style';
const SkeletonRecipeThumb: FC = () => {
  return <div>
            <RecipeImage active />
            <Name active />
        </div>;
};
export default SkeletonRecipeThumb;